import React from 'react';
import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import {
  ContentTypeFilterClause,
  MixedContentItemDefinition,
  SpaceDefinition
} from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { WorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getWorkbookInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';
import { WorkbookCard } from '~src/workbook/components/contentDefinitions/WorkbookCard';
import { ConnectedWorkbookDetailsDialogBody } from '~src/workbook/components/WorkbookDetailsDialog';
import { IWorkbookDetailInfoWithUsage } from '~src/workbook/models/IWorkbookInfo';
import { Workbooks } from '~src/workbook/resources/Workbooks';
import { IWorkbookActions } from '~src/workbook/ServerApi/types/IWorkbookActions';

import { getGenericDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';


export const WorkbookDefinition: MixedContentItemDefinition & SpaceDefinition<'workbook'> = {
  itemType: 'workbook',
  contentType: 'workbook',
  singularName: Messages.workbook,
  pluralName: Messages.workbooks,
  emptyStateMessage: Messages.workbooksEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Workbooks,
  contentFilterKeys: WorkbookContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: WorkbookCard,
  listViewIconUrl: imgPath('workbook_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['workbook']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.workbookUrl(contentId),
  getBasicQuery: () => {
    return Workbooks.all().withExtraParams(WorkbookContentType.extraQueryParams);
  },
  fieldValueResourceType: 'workbook',
  getContentInfo: (contentList: IContentInfo[]) => call(getWorkbookInfos, contentList),
  headerIconPath: () => imgPath('spaces_masthead_workbook.svg'),
  supportedDisplayModes: ['list', 'thumbnail'],
  detailDialogTitle: Messages.workbookDetailsTitle,
  detailDialogBody: (content: IContentInfo<'workbook'>, availableActions: IWorkbookActions, contentLocation?: string) => {
    return (
        <ConnectedWorkbookDetailsDialogBody
        workbook={content as IWorkbookDetailInfoWithUsage}
        allowedActions={availableActions}
        location={contentLocation}
      />
    );
  },
};

